// @ts-strict-ignore
/**
 * Created by ppatton on 12/21/2016.
 */
import { Injectable } from '@angular/core';
import { AppConstants } from '@utils/app.constants';
import { TokenInfo } from '@yggdrasil/core/lib/tracking-client/data-service';

@Injectable()
export class LMContextService {
  private context: LMContext;
  private webAppSpecs: LMWebAppSpec[];
  private _clearPageState = false;
  private _resetBreadcrumbs = false;
  private _isBreadCrumbsDisplayed = false;

  constructor() {}

  getContext(): LMContext {
    return this.context;
  }

  setContext(context: LMContext) {
    this.context = context;
  }

  updateUrlPdlOrDa(urlPdlOrDa: string) {
    this.context.urlPdlOrDa = urlPdlOrDa;
  }

  updateWebApp(webAppSpec: LMWebAppSpec) {
    this.context.webApp = webAppSpec.webAppName;
    this.context.webAppTitle = webAppSpec.webAppTitle;
    LandmarkContext.webApp = webAppSpec.webAppName;
    LandmarkContext.webAppTitle = webAppSpec.webAppTitle;
  }

  updateHomePageTitle(applicationMenuSpec: LMWebAppMenuSpec) {
    this.context.homePageTitle = applicationMenuSpec.homePageTitle;
    LandmarkContext.homePageTitle = applicationMenuSpec.homePageTitle;
  }

  hasAsOfDateInPast(): boolean {
    return this.context && this.context.asOfDate && this.context.asOfDateInPast;
  }

  getAsOfDate(): string {
    return this.context.asOfDate;
  }

  setAsOfDate(date: string) {
    this.context.asOfDate = date;
    if (!this.context.contextSessionKeys) {
      this.context.contextSessionKeys = {};
    }
    this.context.contextSessionKeys[AppConstants.PARAM_CSK_ASOFDATE] = date;
  }

  clearAsOfDate() {
    this.context.asOfDate = '';
    delete this.context.contextSessionKeys[AppConstants.PARAM_CSK_ASOFDATE];
  }

  getAsOfDateInPast(): boolean {
    return this.context.asOfDateInPast;
  }

  setAsOfDateInPast(asOfDateInPast: boolean) {
    this.context.asOfDateInPast = asOfDateInPast;
  }

  getShowDeletedRecords(): boolean {
    return this.context.showdeletedrecords;
  }

  setShowDeletedRecords(show: boolean) {
    this.context.showdeletedrecords = show;
    if (!this.context.contextSessionKeys) {
      this.context.contextSessionKeys = {};
    }
    if (show) {
      this.context.contextSessionKeys[
        AppConstants.PARAM_CSK_SHOWDELETEDRECORDS
      ] = show;
    } else {
      delete this.context.contextSessionKeys[
        AppConstants.PARAM_CSK_SHOWDELETEDRECORDS
      ];
    }
  }

  isBannerInRoute(): boolean {
    if (!this.context) {
      return false;
    }

    if (!this.context.contextSessionKeys) {
      this.context.contextSessionKeys = {};
    }
    const routeInBanner: string =
      this.context.contextSessionKeys[AppConstants.PARAM_CSK_BANNERINROUTE];
    return routeInBanner ? routeInBanner.toLowerCase() === 'true' : false;
  }

  isRouteReuse(): boolean {

    if (!this.context || !this.useNewSpecUrls()) {
      return false;
    }
    if (
      this.context &&
      this.context.contextSessionKeys &&
      this.context.contextSessionKeys[AppConstants.PARAM_CSK_ROUTEREUSE]
    ) {
      return this.context.contextSessionKeys[AppConstants.PARAM_CSK_ROUTEREUSE] === 'true';
    }

    return this.context && this.context.enableRouteReuse;;
  }

  getActorId(): string {
    return this.context.actorId;
  }

  getActorUniqueId(): string {
    return this.context.actorUniqueId;
  }

  getUIType(): LMUIType {
    return this.context.uiType;
  }

  hasConfigAccess(): boolean {
    const webApps = this.getAccessibleWebApps();
    if (!webApps) {
      return false;
    }
    const configArray: LMWebAppSpec[] = webApps.filter((webapp) => {
      if (webapp.webAppName === 'ConfigurationConsole') {
        return webapp;
      }
    });

    return configArray.length > 0;
  }

  isMobileDevice(): boolean {
    return this.getUIType() === 'SMARTPHONE' || this.getUIType() === 'TABLET';
  }

  isSmartPhone(): boolean {
    return this.getUIType() === 'SMARTPHONE';
  }

  get disableUserPageHit(): string {
    return this.context && this.context.disableUserPageHit
      ? this.context.disableUserPageHit
      : 'none';
  }

  get configStamp(): number {
    return this.context.configStamp;
  }

  get uiLoadingIndicatorTimeout(): number {
    if (this.context.uiLoadingIndicatorTimeout > 0) {
      // value times 1000 to get milliseconds
      return this.context.uiLoadingIndicatorTimeout * 1000;
    }

    return this.context.uiLoadingIndicatorTimeout;
  }

  get uiPagingRequestWaitTime(): number {
    if (this.context.uiPagingRequestWaitTime > 0) {
      // value times 1000 to get milliseconds
      return this.context.uiPagingRequestWaitTime * 1000;
    }

    return this.context.uiPagingRequestWaitTime;
  }

  get isUiPagingRequestWaitTimeEnabled(): boolean {
    return this.context.uiPagingRequestWaitTime > 0;
  }

  userDefinedStatesPageSizeAndIndicator(): boolean {
    return this.context.userDefinedStatePageSizeAndFilter;
  }

  userDefinedStatesDefaultPageSize(): number {
    return this.context.userDefinedStateDefaultPageSize;
  }

  casualMode(): boolean {
    if (this.context && this.context.contextSessionKeys) {
      return this.context.contextSessionKeys['csk.casualMode'] === 'true';
    }

    return false;
  }

  isDeveloper(): boolean {
    return this.context.developer;
  }

  isGenAISummarize(): boolean {
    return this.context.genAISummarize;
  }

  getGenAISummarizePrompt(): string {
    return this.context.genAISummarizePrompt;
  }

  /**
   * Whether or not to display the context for a mingle
   * widget.
   * @returns {boolean}
   */

  inMingleWidget(): boolean {
    return this.context.inMingleWidget;
  }

  insideInforGo(): boolean {
    return this.context.insideInforGo;
  }

  inMingleInbox(): boolean {
    if (this.inMingle()) {
      return !!(
        this.context.contextSessionKeys &&
        this.context.contextSessionKeys['csk.mi']
      );
    }
    return false;
  }

  inMingleOverlay(): boolean {
    return this.context.inMingleOverlay;
  }

  // @deprecated
  isXiFull(): boolean {
    return false;
    // return this.context.uiHarness === 'xifull';
  }

  isAnyTrackingEnabled(): boolean {
    return (
      this.isMonocleEnabled() || this.isSumoEnabled() || this.isTrackerEnabled()
    );
  }

  isMonocleEnabled(): boolean {
    if (!this.context || !this.context.enableUserPageHit) {
      return false;
    }
    return this.context && this.context.enableUserPageHit;
  }

  isTrackerEnabled(): boolean {
    if (!this.context || !this.context.disableUserPageHit) {
      return false;
    }
    // the browser expose a methed in the object Crypto object called randomUUID but only when the server is running in https
    // if the tracker is enabled but the server is not in https javascript will throw an error when the library uses the randomUUID method.
    // To avoid this and allow the library to work in development mode we define the method in the Crypto object so the library can use it
    try {
      crypto.randomUUID();
    } catch (e) {
      crypto.randomUUID = () => 'landmarkHTTPdevelopmentUUID' as '${string}-${string}-${string}-${string}-${string}';
    }

    return (
      this.context.disableUserPageHit !== 'tracker' &&
      this.context.disableUserPageHit !== 'both'
    );
  }

  isSumoEnabled(): boolean {
    if (!this.context || !this.context.disableUserPageHit) {
      return false;
    }
    return (
      this.context.disableUserPageHit !== 'sumo' &&
      this.context.disableUserPageHit !== 'both'
    );
  }

  getCompactnessMode(): LMCompactnessMode {
    if (this.context && this.context.compactnessMode) {
      return this.context.compactnessMode;
    }

    return 'compact';
  }

  testVersion(): LMTestVersion {
    if (this.context && this.context.testVersion) {
      return this.context.testVersion;
    }

    return 1;
  }

  isHideMenuBar(): boolean {
    if (this.context && this.context.contextSessionKeys) {
      return this.context.contextSessionKeys['csk.hidemenubar'] === 'true';
    }

    return false;
  }

  isHideTitlebar(): boolean {
    if (this.context && this.context.contextSessionKeys) {
      return this.context.contextSessionKeys['csk.hidetitlebar'] === 'true';
    }

    return false;
  }

  hideDeliveredReports(): boolean {
    const configuredFeature = this.context.configuredFeatures.includes('HideDeliveredReports');
    return configuredFeature || this.context.hideDeliveredReports;
  }

  useLazyLoadForm(): boolean {
    if (
      this.context &&
      this.context.contextSessionKeys &&
      this.context.contextSessionKeys['csk.uselazyloadform']
    ) {
      return this.context.contextSessionKeys['csk.uselazyloadform'] === 'true';
    }

    return true;
  }

  allowAnonymousAccess(): boolean {
    return this.context.allowAnonymousAccess;
  }

  isAnonymousUser(): boolean {
    return this.context.isAnonymousUser;
  }

  isGuestUser(): boolean {
    return this.context.isGuestUser;
  }

  getLog(): number {
    if (this.context && this.context.contextSessionKeys) {
      const key = this.context.contextSessionKeys['csk.log'];
      const value = Number(key);

      if (isNaN(value)) {
        return 0;
      }

      if (value >= 1 && value <= 4) {
        return value;
      }
    }

    return 0;
  }

  getLogToClient(): boolean {
    if (this.context && this.context.contextSessionKeys) {
      const key = this.context.contextSessionKeys['csk.logtoclient'];
      const value = key === 'true';
      return key ? value : false;
    }

    return false;
  }

  setAccessibleWebApps(webApps: LMWebAppSpec[]) {
    this.webAppSpecs = webApps;
  }

  getAccessibleWebApps(): LMWebAppSpec[] {
    return this.webAppSpecs;
  }

  getCurrentWebAppSpec(): LMWebAppSpec {
    if (this.context.webApp === 'web') {
      const webWebAppSpec: LMWebAppSpec = {
        webAppUrl: '',
        webAppName: 'web',
        webAppIconUrl: '',
        webAppDescription: '',
        webAppTitle: 'Web',
        navigationMenuUrl: '',
        menu: false,
        // menuSecurityEnabled: false,
      };
      return webWebAppSpec;
    }

    const result: LMWebAppSpec[] = this.webAppSpecs.filter(
      (webAppSpec) => webAppSpec.webAppName === this.context.webApp
    );
    if (result.length !== 1) {
      throw 'cannot find webAppSpec for ' + this.context.webApp;
    }
    return result[0];
  }

  inMingle(): boolean {
    return this.getLogicalId().length > 0;
  }

  getLogicalId(): string {
    return this.context && this.context.logicalId ? this.context.logicalId : '';
  }

  getLidKey(): string {
    let lidKey = '';
    if (this.context?.contextSessionKeys) {
      lidKey = this.context.contextSessionKeys['csk.lidkey'] || '';
    }
    return lidKey;
  }

  getInforOSPortalVersion(): string {
    return this.context && this.context.inforOSPortalVersion
      ? this.context.inforOSPortalVersion
      : '';
  }

  getWebpartScreenId(): string {
    return this.context && this.context.webpartScreenId
      ? this.context.webpartScreenId
      : '';
  }

  getUrlPdlOrDa() {
    return this.context && this.context.urlPdlOrDa
      ? this.context.urlPdlOrDa
      : '';
  }

  getWebApp() {
    return this.context && this.context.webApp ? this.context.webApp : '';
  }

  getToastMessagePosition(): LMToastPosition {
    return this.context?.uiToastMessagePosition
      ? this.context.uiToastMessagePosition
      : 'BLANK';
  }

  getToastMessageDuration(): LMToastDuration {
    return this.context?.uiToastMessageDuration
      ? this.context.uiToastMessageDuration
      : 'BLANK';
  }

  /**
   * Placing here for a lack of a better spot. This is set in the banner when
   * navigating to a screen. That screen will have it's page state cleared.
   * Page state should only be used when going back and forward with the
   * browser button or through standard screen navigation.
   * @returns
   */
  getClearPageState(): boolean {
    return this.context ? this.context.clearPageState : this._clearPageState;
  }

  setClearNextPageState(clearPageState: boolean, resetBreadCrumbs?: boolean): void {
    this._clearPageState = clearPageState;
    this._resetBreadcrumbs = (resetBreadCrumbs === undefined) ? clearPageState : resetBreadCrumbs;
    if (this.context) {
      this.context.clearPageState = this._clearPageState;
      this.context.resetBreadCrumbs = this._resetBreadcrumbs;
    }
  }

  resetBreadCrumbs(): boolean {
    return this.context ? this.context.resetBreadCrumbs : this._resetBreadcrumbs;
  }
  // @deprecated
  is3_5Content(appDisplay: string) {
    // This method is used by application or banner menu implementation
    // The option to override to 3x in setting dialog is no longer valid.
    // All webapps are in 4.x in pedro. Returning false
    return false;
  }

  public drillAroundWindow(): boolean {
    return this.context && this.context.drillAroundWindow;
  }

  public drillAroundEnabled(): boolean {
    if (
        this.context &&
        this.context.contextSessionKeys &&
        this.context.contextSessionKeys['csk.drillaround']
    ) {
      return this.context.contextSessionKeys['csk.drillaround'] === 'true';
    }

    if (this.context && this.context.drillAroundEnabled) {
      return true;
    }

    return false;
  }

  public genAIEnabled(): boolean {
    return this.context && this.context.genAIEnabled;
  }

  public  genAISummarizeBase64(): boolean {
    return this.isGenAISummarize() && this.context.base64Opt;
  }

  public useNewSpecUrls(): boolean {
    if (
      this.context &&
      this.context.contextSessionKeys &&
      this.context.contextSessionKeys['csk.newspecurl']
    ) {
      return this.context.contextSessionKeys['csk.newspecurl'] === 'true';
    }

    return this.context && this.context.useNewSpecUrls;
  }

  disablePageState(): boolean {
    if (
      this.context &&
      this.context.contextSessionKeys &&
      this.context.contextSessionKeys['csk.disablepagestate']
    ) {
      return this.context.contextSessionKeys['csk.disablepagestate'] === 'true';
    }

    return false;
  }

  isGenProductLine(): boolean {
    if (
      this.context &&
      this.context.contextSessionKeys &&
      this.context.contextSessionKeys['csk.gen']
    ) {
      return this.context.contextSessionKeys['csk.gen'] === 'true';
    }
    return false;
  }

  useSingleSelectList(): boolean {
    if (
      this.context &&
      this.context.contextSessionKeys &&
      this.context.contextSessionKeys['csk.usesingleselectlist']
    ) {
      return (
        this.context.contextSessionKeys['csk.usesingleselectlist'] === 'true'
      );
    }

    return this.context?.useSingleSelectList;
  }

  enableMultipleSearchTerms(): boolean {
    if (
      this.context &&
      this.context.contextSessionKeys &&
      this.context.contextSessionKeys['csk.enablemultiplesearchterms']
    ) {
      return (
        this.context.contextSessionKeys['csk.enablemultiplesearchterms'] ===
        'true'
      );
    }

    return this.context?.enableMultipleSearchTerms;
  }

  useMultiSelectKeyField(): boolean {
    if (this.useSingleSelectList()) {
      if (this.enableMultipleSearchTerms()) {
        return true;
      }

      // also allow for csk.usemultiselectkeyfield since this older csk was communicated
      if (
        this.context &&
        this.context.contextSessionKeys &&
        this.context.contextSessionKeys['csk.usemultiselectkeyfield']
      ) {
        return (
          this.context.contextSessionKeys['csk.usemultiselectkeyfield'] ===
          'true'
        );
      }
    }

    return false;
  }

  enableMaintainingSelectedValues(): boolean {
    if (!this.useSingleSelectList() || !this.enableMultipleSearchTerms()) {
      return false;
    }

    if (
      this.context &&
      this.context.contextSessionKeys &&
      this.context.contextSessionKeys['csk.enablemaintainingselectedvalues']
    ) {
      return (
        this.context.contextSessionKeys[
          'csk.enablemaintainingselectedvalues'
        ] === 'true'
      );
    }

    return !!this.context?.enableMaintainingSelectedValues;
  }

  enableMaintainingSelectedRows(): boolean {
    return !!this.context.enableMaintainingSelectedRows;
  }

  useMingleStartMode(): boolean {
    if (this.inMingle()) {
      if (
        this.context &&
        this.context.contextSessionKeys &&
        this.context.contextSessionKeys['csk.useminglestartmode']
      ) {
        return (
          this.context.contextSessionKeys['csk.useminglestartmode'] === 'true'
        );
      }
    }
    return false;
  }

  enablePageSpecRefactor(): boolean {
    if (this.context) {
      if (
        this.context.contextSessionKeys &&
        this.context.contextSessionKeys['csk.pagespec-refactor'] &&
        this.context.contextSessionKeys['csk.pagespec-refactor'] === 'false'
      ) {
        return false;
      }

      if (
        this.context.pagespec_refactor !== undefined &&
        this.context.pagespec_refactor === false
      ) {
        return false;
      }
    }
    return true;
  }

  isStepUpAuthetication(): boolean {
    if (
      this.context &&
      this.context.stepUpAuthentication !== undefined &&
      this.context.stepUpAuthentication
    ) {
      // This flag is only for one time consumption.
      this.resetStepUpAuthentication();
      return true;
    }
    return false;
  }

  isApplicationMenuV3() {
    if (this.isMobileDevice() && this.context.uiMenuVersion === 'v3') {

      if (this.context.allowAnonymousAccess) {
        return this.context.uiExternalMenuVersion === 'v3';
      }

      return true;
    }

    if (this.context.allowAnonymousAccess) {
      return this.context.uiExternalMenuVersion === 'v3';
    }

    return (
      this.context.uiMenuVersion !== 'v1' && this.context.uiMenuVersion !== 'v2'
    );
  }

  isApplicationMenuV2() {
    if (this.isMobileDevice() && this.context.uiMenuVersion === undefined) {
      if (this.context.allowAnonymousAccess) {
        return this.context.uiExternalMenuVersion === 'v2';
      }

      return true;
    }

    if (this.context.allowAnonymousAccess) {
      return this.context.uiExternalMenuVersion === 'v2';
    }

    return this.context.uiMenuVersion === 'v2';
  }

  isApplicationMenuV1() {
    if (this.isMobileDevice() && this.context.uiMenuVersion === undefined) {
      if (this.context.allowAnonymousAccess) {
        return (
          this.context.uiExternalMenuVersion !== 'v2' &&
          this.context.uiExternalMenuVersion !== 'v3'
        );
      }

      return false;
    }

    if (this.context.allowAnonymousAccess) {
      return (
        this.context.uiExternalMenuVersion !== 'v2' &&
        this.context.uiExternalMenuVersion !== 'v3'
      );
    }

    return this.context.uiMenuVersion === 'v1';
  }

  applicationMenuVersion(): 'v1' | 'v2' | 'v3' {
    if (this.isApplicationMenuV1()) {
      return 'v1';
    }

    if (this.isApplicationMenuV2()) {
      return 'v2';
    }

    if (this.isApplicationMenuV3()) {
      return 'v3';
    }
  }

  simplifyOptionsMenu(): boolean {
    return this.context.simplifyOptionsMenu;
  }

  getOptionsConfigFeatures(): LMOptionsConfigFeatures {
    const optionsConfigFeatures: LMOptionsConfigFeatures = {
      disallowExport: this.context.disallowExport,
      configuredFeatures: this.context.configuredFeatures,
      noPdfInConfig: this.context.configuredFeatures.indexOf(AppConstants.FEATURE_ExportToPDF) !== -1,
      noCsvInConfig: this.context.configuredFeatures.indexOf(AppConstants.FEATURE_ExportToCSV) !== -1,
      noCreateReportInConfig: this.isConfigFeatureEnabled(AppConstants.FEATURE_CreateReport),
      noConfigInConfig: this.context.configuredFeatures.indexOf(AppConstants.FEATURE_Configuration) !== -1,
      noPersonlizationInConfig: this.context.configuredFeatures.indexOf(AppConstants.FEATURE_Personalization) !== -1,
      noLimitedInConfig: this.context.configuredFeatures.indexOf(AppConstants.FEATURE_LimitedListPersonalization) !== -1,
    };
    return optionsConfigFeatures;
  }

  private resetStepUpAuthentication() {
    this.context.stepUpAuthentication = false;
  }

  hasAccessibilityModeParameter(): boolean {
    return (
      this.context?.contextSessionKeys?.['csk.accessibility'] !== undefined
    );
  }

  getAccessibilityModeParameterValue(): boolean {
    return this.context?.contextSessionKeys?.['csk.accessibility'] === 'true';
  }

  hasDBSessionDebugMode(): boolean {
    return (
      this.context?.contextSessionKeys?.['csk.dbsessiondebug'] !== undefined
    );
  }

  isSecSessionDebugMode(): boolean {
    return this.context?.contextSessionKeys?.['csk.secsessiondebug'] === 'true';
  }

  getDBSessionDebugId(): string {
    return this.context?.contextSessionKeys?.['csk.dbsessiondebug'];
  }

  hasDBDebugLevel(): boolean {
    return (
      this.context?.contextSessionKeys?.['csk.dbsessiondebuglevel'] !==
      undefined
    );
  }

  getDBDebugLevel(): string {
    return this.context?.contextSessionKeys?.['csk.dbsessiondebuglevel'];
  }

  hasDBSessionTrace(): boolean {
    return this.context?.contextSessionKeys?.['csk.lpltrace'] !== undefined;
  }

  getDBSessionTrace(): boolean {
    return this.context?.contextSessionKeys?.['csk.lpltrace'] === 'true';
  }

  isConfigFeatureEnabled(featureName: string): boolean {
    return this.context.configuredFeatures.indexOf(featureName) !== -1;
  }

  getFilterBarModeSetInCsk(): string {
    return this.context?.contextSessionKeys?.['csk.filterbarmode'];
  }

  isFilterBarOnPowerMode(): boolean {
    if (this.context?.allowAnonymousAccess) {
      return this.context?.uiExternalAppFilterBarMode === 'power';
    }

    return this.context?.uiAppFilterBarMode === 'power';
  }

  public getTrackerAccess(): TokenInfo {
    const json = this.context && this.context.trackerAccess ? JSON.parse(this.context?.trackerAccess) : {};
    const access: TokenInfo = {
      accessToken: json.accessToken,
      tokenType: json.tokenType,
      expiresIn: json.expiresIn,
      refreshToken: json.refreshToken,
      baseUrl: json.publicUrl,
    };
    return access;
  }

  public getTrackerPublicUrl(): string {
    if (!this.context?.trackerAccess) {
      return 'NOURL';
    }
    const json = JSON.parse(this.context?.trackerAccess);
    return json.publicUrl;
  }

  showUserListView(): boolean {
    // Using configuration parameter UIEnableSavedViews
    // return this.context?.contextSessionKeys?.['csk.savedSearch'] === 'true'
    const enableSavedSearch = this.context?.enableSavedSearch || false;
    return enableSavedSearch && !this.isAnonymousUser() && !this.casualMode();
  }

  public menuSearchOpenIndex(): string {
    return this.context?.menuSearchOpenIndex;
  }

  public pdfPollEnabled(): boolean {
    return this.context?.contextSessionKeys?.['csk.pollforpdf'];
  }

  public setMingleActivityCookie() {
    // Moving it to Context Service from Context Util. Angular creates the service objects for injection
    // and context util was created before context service resulting in issues related to registering Ming.le handlers.
    const data = {
      applicationName: this.getContext().webApp,
      updateCookie: true,
    };
    infor.companyon.client.sendMessage('updateUserActivityCookie', data);
  }

  public hidePageLevelActions() {
    return this.context?.hidePageLevelActions === true;
  }

  public isDataModificationNotAllowed(): boolean {
    return this.hasAsOfDateInPast() || this.isArchiveMode();
  }

  public isArchiveMode(): boolean {
    return !!this.context?.archiveMode;
  }

  public setArchiveMode(viewArchive: boolean) {
    if (!this.context?.contextSessionKeys) {
      this.context.contextSessionKeys = {};
    }
    
    if (!this.isConfigFeatureEnabled(AppConstants.FEATURE_ShowArchive)) {
      this.context.archiveMode = false;
      delete this.context.contextSessionKeys[AppConstants.PARAM_CSK_VIEWARCHIVE];
      return;
    }

    this.context.archiveMode = viewArchive;
    if (viewArchive) {
      this.context.contextSessionKeys[AppConstants.PARAM_CSK_VIEWARCHIVE] = true;
    } else {
      delete this.context.contextSessionKeys[AppConstants.PARAM_CSK_VIEWARCHIVE];
    }
  }

  // Toggle for the list detail on side
  // public pocListSideDetails(): boolean {
  //   if (this.context && this.context.contextSessionKeys) {
  //     return this.context.contextSessionKeys['csk.pocListDetailSide'] === 'true';
  //   }
  //
  //   return false;
  // }

  // Toggle for breadcrumbs feature
  public showBreadcrumbs(): boolean {
    if (!(this.context && (this.allowAnonymousAccess() || this.isMobileDevice() || this.inMingleInbox()
      || this.inMingleWidget() || this.inMingleOverlay() || this.insideInforGo()))) {
      const showBreadcrumbs = this.context?.showBreadcrumbs || false;
      if (showBreadcrumbs) {
        return true;
      }
      if (this.context?.contextSessionKeys) {
        return this.context.contextSessionKeys['csk.bcnav'] === 'true';
      }
    }
    return false;
  }

  /**
   * Is the breadcrumb web component visible in Banner? This is used to calculate height of main content area.
   */
  public isBreadCrumbsDisplayed(): boolean {
    return this._isBreadCrumbsDisplayed;
  }

  public setIsBreadCrumbsDisplayed(show: boolean) {
    this._isBreadCrumbsDisplayed = show;
  }

  public createReportFromFormEnabled(): boolean {
    return this.isConfigFeatureEnabled(AppConstants.FEATURE_CreateReport);
  }
}

(function () {
  // The crypto object is only available on newer browser versions and when running https.
  // It is used to generate a UUID in the tracker library. They have a check internally that will
  // not allow the UI to continue if they cannot find crypto defined. Since we frequently run in http
  // we fake the check out by defining something for it to find if it does not exist so developments is
  // not limited by the tracker check.

  // This is run at load time. It does not work to use context variables or methods
  // So we only do this if cli - true and we are running http not https
  if (location.protocol.indexOf("https") < 0 && location.search.indexOf("csk.cli=true") >= 0)
  {
    try {
      crypto.randomUUID();
    } catch (e) {
      crypto.randomUUID = () => 'landmarkHTTPdevelopmentUUID' as '${string}-${string}-${string}-${string}-${string}';
    }
  }
})();